module.exports = __webpack_public_path__ + "img/desburocratizacao_ouro.083d435c.png";